const LoginPage = () => import('@/pages/login/LoginPage.vue');
const LoginPageOkta = () => import('@/pages/login/LoginPageOkta.vue');
const LoginPageOpenID = () => import('@/pages/login/LoginPageOpenID.vue');

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    id: 'login',
    component: LoginPage,
    meta: { hideNavbar: true },
    omitFromNav: true,
  },
  // Allow specific navigation to each login page, while /login will use the component of the configured default
  {
    path: '/auth-openid/login',
    name: 'auth-openid/login',
    id: 'auth-openid/login',
    component: LoginPageOpenID,
    meta: { hideNavbar: true },
    omitFromNav: true,
  },
  {
    path: '/ow-auth/login',
    name: 'LoginPageOkta',
    id: 'ow-auth/login',
    component: LoginPageOkta,
    meta: { hideNavbar: true },
    omitFromNav: true,
  },
];

export default routes;
